import React, { useContext, useEffect, useState } from "react";
import "../../assets/styles/sidebar.scss";
import { routes } from "../../router";
import { IconSignOut, IconWarning } from "../../icons/Icon";
import NavItem from "./parts/NavItem";
import { BIG_LOGO, SMALL_LOGO } from "../../constants/images";
import { StoreContext } from "../../store/StoreContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { SMU_TOKEN, SMU_USER } from "../../constants";
import _ from "lodash";
import { makeTree } from "../../helpers";
import { COLOR_PRIMARY } from "../../constants/colors";
import { logoutUser } from "../../api/users";

const Sidebar = () => {
  const navigate = useNavigate();
  const {
    sidebarExpand,
    setSidebarExpand,
    setCurrentRoute,
    setLoggedUser,
    skirts,
    loggedUser
  } = useContext(StoreContext);

  const [menu, setMenu] = useState([]);
  useEffect(() => {
    let _menu = routes.filter((r) => r.isMenu);

    if (skirts.length > 0) {
      let _skirts = skirts.map((skirt) => ({
        ...skirt,
        parent: skirt?.parent || 0,
      }));
      _skirts = makeTree(_skirts, 0);
      _menu[2]["children"] = _skirts;
    }

    setMenu(_menu);
  }, [skirts]);

  const addCurrentRoute = (route) => {
    localStorage.setItem("currentRoute", JSON.stringify(route));
    setCurrentRoute(route);
  };

  const logout = () => {
    Swal.fire({
      title: "¿Deseas cerrar sesión?",
      showCancelButton: true,
      confirmButtonText: "Cerrar sesión",
      confirmButtonColor: COLOR_PRIMARY,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      const _logoutUser = new FormData();

      _logoutUser.append("username", loggedUser?.username);

      logoutUser(_logoutUser)
      .then(({ error }) => {
        if (!!error) throw new Error(error.message);

        setLoggedUser(null);
        localStorage.removeItem(SMU_TOKEN);
        localStorage.removeItem(SMU_USER);
        navigate("/access", { replace: true });
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      })

    });
  };

  const goToTableHelp = () => {
    //control(false);
    window.open("https://smuenprod.service-now.com/sp", "_blank");
  };

  return (
    <>
      <div
        className={`sidebar shadow ${sidebarExpand ? "expand" : ""}`}
        onMouseEnter={() => setSidebarExpand(true)}
        onMouseLeave={() => setSidebarExpand(false)}
      >
        <div className="header">
          <img src={SMALL_LOGO} alt="LOGO" className="small-logo" />
          <img src={BIG_LOGO} alt="LOGO" className="big-logo" />
        </div>

        <div className="body">
          <ul className="menu main px-0 py-3 mt-2 mb-4">
            {menu.map((item) => (
              <li key={item.id} className="py-2 px-3">
                <NavItem route={item} addCurrentRoute={addCurrentRoute} />
              </li>
            ))}
          </ul>

          <ul className="menu px-0 mt-auto">
            <li className="menu-item px-3" onClick={() => logout()}>
              <div className="menu-item-main">
                <div className="icon">
                  <IconSignOut color="#33383F" />
                </div>
                <span className="text ms-3">Cerrar sesión</span>
              </div>
            </li>
            <div className="divider my-2 mx-auto w-100" />
            <li className="menu-item px-3" onClick={() => goToTableHelp()}>
              <div className="menu-item-main">
                <div className="icon">
                  <IconWarning color="#33383F" />
                </div>
                <span className="text ms-3">Mesa de Ayuda</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
